import { STORAGE_KEYS } from '@/core/constants/storage-keys'
import { requestNotificationPermission } from '@/core/firebase'
import { storageService } from '@/core/services/storage'
import { useActionState, useCallback, useTransition } from 'react'
import { subscribePushNotificationAction } from '../use-cases/subscribe-push-notification.usecase'

const getDeviceId = () => {
  let deviceId = storageService.getItem(STORAGE_KEYS.deviceId) as string
  if (deviceId) return deviceId

  deviceId = crypto.randomUUID()
  storageService.setItem(STORAGE_KEYS.deviceId, deviceId)

  return deviceId
}

export const useInitNotifications = () => {
  const [, subscribePushNotification] = useActionState(
    subscribePushNotificationAction,
    null,
  )
  const [, startTransition] = useTransition()
  const initNotifications = useCallback(() => {
    requestNotificationPermission().then(res => {
      if (!res) return
      const deviceId = getDeviceId()
      storageService.setItem(STORAGE_KEYS.fcmToken, res.fcmToken)
      startTransition(() =>
        subscribePushNotification({ fcmToken: res.fcmToken, deviceId }),
      )
    })
  }, [])

  return initNotifications
}
